import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomFieldBaseInput } from './custom-field-base-input.directive';
import { SharedFormModule } from '@shared/modules';

@Component({
  selector: 'cwt-custom-field-enum-input',
  standalone: true,
  imports: [
    CommonModule,
    SharedFormModule,
  ],
  template: `
    <nz-form-item>
      <nz-form-label>{{customField.name | cwtDictionary}}</nz-form-label>
      <nz-form-control>
          <nz-select 
              [disabled]="disabled"
              [(ngModel)]="value" 
              [nzMode]="customField.isMultiSelect ? 'tags' : 'default'">
              <nz-option *ngFor="let enumValue of customField.enumValues" [nzValue]="enumValue.key" [nzLabel]="enumValue.label | cwtDictionary"></nz-option>
          </nz-select>
      </nz-form-control>
    </nz-form-item>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomFieldEnumInputComponent extends CustomFieldBaseInput<string> {

}
